import { IState } from '../../../../../store/types';
import { connect } from 'react-redux';
import { OneTimeTooltipSelectArrow } from '../../components/OneTimeTooltipSelectArrow/OneTimeTooltipSelectArrow';
import { IOneTimeTooltipSelectArrowEvents, IOneTimeTooltipSelectArrowFields } from '../../components/OneTimeTooltipSelectArrow/types';
import { getVideoTeacherUserActiveId } from '../../../../../store/videos/selectors';

const mapStateToProps = (
	dispatch: any
) => {
	return (
		state: IState
	): IOneTimeTooltipSelectArrowFields => {
		let show = true;
		const teacherId = getVideoTeacherUserActiveId(state);
		if (teacherId > 0) {
			show = false;
		}
		
		return {
			show,
		}
	};
}

const mapDispatchToProps = (
	dispatch: any
): IOneTimeTooltipSelectArrowEvents => ({
});

export const OneTimeTooltipSelectArrowHOC = connect(
	mapStateToProps,
	null,
)(OneTimeTooltipSelectArrow) as any;

OneTimeTooltipSelectArrowHOC.displayName = 'OneTimeTooltipSelectArrowHOC';
